import React from 'react';
import { PersonalizedInsightsProps } from '../../../types/health-tools/predictive-types';
import HealthCard from '../ui/HealthCard';
import { Zap } from 'lucide-react';

/**
 * Personalized Insights Component
 * 
 * Displays AI-generated health insights and recommendations based on the user's data
 * 
 * @param insights - Array of insight/recommendation strings
 * @param className - Additional CSS classes
 */
const PersonalizedInsights: React.FC<PersonalizedInsightsProps> = ({
  insights,
  className = '',
}) => {
  return (
    <HealthCard 
      title="Personalized Insights" 
      icon={Zap} 
      className={className}
    >
      {insights && insights.length > 0 ? (
        <ul className="space-y-4">
          {insights.map((insight, index) => (
            <li key={index} className="flex">
              <div className="w-2 h-2 rounded-full bg-[var(--brand-primary)] mt-1.5 mr-2"></div>
              <div>
                <p className="text-sm text-[var(--text-primary)]">{insight}</p>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-center text-[var(--text-secondary)] py-4">
          No personalized insights available yet. Continue tracking your health data to receive tailored recommendations.
        </p>
      )}
      
      <button className="w-full mt-4 bg-[var(--background-surface)] hover:bg-[var(--background-interactive)] text-[var(--text-primary)] text-sm py-2 rounded-lg transition-colors">
        View More Insights
      </button>
      
      <p className="text-xs text-[var(--text-secondary)] mt-3">
        These insights are generated based on your health data patterns and health goals. 
        Always consult with healthcare professionals before making significant health changes.
      </p>
    </HealthCard>
  );
};

export default PersonalizedInsights; 